/*  Shared  */
import { CellContext } from '@tanstack/react-table';
import { User, UserEmail } from 'objects/User';

/*  React  */
import React from 'react';

export const UserEmailCell = <TData,>({
    cell,
    className,
    iconOnly,
    noTooltip,
    useWhiteFont,
    id,
    includeClients
}: CellContext<TData, unknown> & {
    className?: string;
    iconOnly?: boolean;
    noTooltip?: boolean;
    useWhiteFont?: boolean;
    id?: string;
    includeClients?: boolean;
}): React.ReactElement => (
    <User
        data={cell.getValue() as typeof User}
        id={id}
        includeClients={includeClients}
    >
        <UserEmail
            className={className}
            iconOnly={iconOnly}
            noTooltip={noTooltip}
            useWhiteFont={useWhiteFont}
        />
    </User>
);
